// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
export const getPostcode = state => state.addressSearchReducer.postcode;
export const getAddresses = state => state.addressSearchReducer.addresses;
